import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, salesHomeRoute } from 'config/Api.Config';
import useSalesContract from './Sales.Contract.Hooks';
import ContractAdjustDistributions from './sections/adjustDistributions/Contract.AdjustDistributions';
import ContractVoidCancellation from './sections/cancellation/Contract.VoidCancellation';
import ContractResendConsent from './sections/resendConsent/Contract.ResendConsent';
import ContractInfo from './sections/Sales.Contract.Info';
import ContractList from './sections/Sales.Contract.List';
import ContractTransferToNewClient from './sections/transferToNewClient/Contract.TransferToNewClient';
import ContractRefundProcess from './sections/refund/Contract.RefundProcess';
import ContractRefundCancellation from './sections/cancellationRefund/Contract.RefundCancellation';
import ContractPaidActiveModal from './other/ContractPaidActiveModal';

export const salesContractIndexRoute = salesHomeRoute + '/contract/:action?/:id?';
export default function SalesContractIndex() {
  const contractHook = useSalesContract();

  if (!contractHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={contractHook}
        render={({ pageRouter }) => (
          <>
            {pageRouter.params?.id &&
              (pageRouter.params.action === 'cancellation-restricted' ||
                pageRouter.params.action === 'cancellation-unrestricted') && <ContractRefundCancellation />}
            {pageRouter.params?.id && pageRouter.params.action === 'cancellation-void' && <ContractVoidCancellation />}
            {pageRouter.params?.id && pageRouter.params.action === 'info' ? <ContractInfo /> : <ContractList />}
            {pageRouter.params?.id && pageRouter.params.action === 'adjustDistributions' && (
              <ContractAdjustDistributions />
            )}
            {pageRouter.params?.id && pageRouter.params.action === 'resendConsent' && <ContractResendConsent />}
            {pageRouter.params?.id && pageRouter.params.action === 'transfer' && <ContractTransferToNewClient />}
            {pageRouter.params?.id && pageRouter.params.action === 'refund' && (
              <ContractRefundProcess />
            )}
            {pageRouter.params?.action === 'paid-active' && <ContractPaidActiveModal />}
          </>
        )}
      />
    </>
  );
}
